import { C100Row } from '../../_types/carnivore100.type'

export type SortKey =
  | 'rank' | 'ticker' | 'name' | 'sector' | 'market'
  | 'price' | 'dayChangePct' | 'timeframeChangePct'
export type SortDir = 'asc' | 'desc'

export function filterRows(
  rows: C100Row[],
  opts: { search: string; sector: string; market: string }
): C100Row[] {
  const q = opts.search.trim().toLowerCase()
  return rows.filter(r => {
    if (q && !r.ticker.toLowerCase().includes(q) && !r.name.toLowerCase().includes(q)) return false
    if (opts.sector !== 'All' && r.sector !== opts.sector) return false
    if (opts.market !== 'All' && r.market !== opts.market) return false
    return true
  })
}

export function sortRows(rows: C100Row[], key: SortKey, dir: SortDir): C100Row[] {
  const mult = dir === 'asc' ? 1 : -1
  const copy = [...rows]
  copy.sort((a, b) => {
    const av = a[key]
    const bv = b[key]
    // nulls always last, regardless of direction
    if (av === null && bv === null) return 0
    if (av === null) return 1
    if (bv === null) return -1
    if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * mult
    return String(av).toLowerCase().localeCompare(String(bv).toLowerCase()) * mult
  })
  return copy
}

export function uniqueSectors(rows: C100Row[]): string[] {
  return Array.from(new Set(rows.map(r => r.sector).filter(Boolean))).sort()
}

export function uniqueMarkets(rows: C100Row[]): string[] {
  return Array.from(new Set(rows.map(r => r.market).filter(Boolean))).sort()
}
